import React from 'react';

import type { GlobalCmsRecord } from './cms-provider/global-cms-provider';

export const GlobalCmsContent = React.createContext<GlobalCmsRecord>(null as never);
